<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="aboutKYPage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h2 *ngIf="!isEnglish()">{{ 'aboutKunYou.identity' | translate }}</h2>
                        <div class="pageTitle">
                            <h1>{{ 'aboutKunYou.title' | translate }}</h1>
                        </div>
                        <p>{{ 'aboutKunYou.desc' | translate }}</p>
                    </div>
                </div>
            </div>
            <!-- <div class="copInfoArea">
				<div class="copInfoBox">
					<div class="nameBox">
						<h2>資安與數據整合的引領者</h2>
						<p>（KunYou Technology Co., LTD.）</p>
					</div>
					<div class="introBox">
						<p>Providing a Number 1 Service. 敏捷專案規劃、雲端創新，成就您在市場的數位優勢</p>
					</div>
				</div>
			</div> -->
            <div class="beliefAndCultureArea">
                <div class="beliefBox">
                    <div class="imgBox">
                        <img
                            [src]="
                                !isEnglish()
                                    ? '../../../../assets/images/aboutKYPage/stairs.jpg'
                                    : '../../../../assets/images/aboutKYPage/stairs-english.jpg'
                            "
                            alt=""
                            width="100%" />
                    </div>
                    <div class="wordBox">
                        <h2>{{ 'aboutKunYou.subtitle' | translate }}</h2>
                        <p class="para1">
                            {{ 'aboutKunYou.content1' | translate }}
                        </p>
                        <p class="para2">
                            {{ 'aboutKunYou.content2' | translate }}
                        </p>
                        <p class="para3">
                            {{ 'aboutKunYou.content3' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- <div class="ceoArea">
				<div class="ceoBox">
					<div class="imgBox">
						<img
							src="../../../../assets/images/aboutKYPage/ceo.png"
							alt=""
							width="100%"
						/>
					</div>
					<div class="wordBox">
						<p>
							我期待將坤侑科技打造成為安全科技領域的標竿，相信科技的力量，可以為國家帶來積極的改變和影響。
							<br />
							<br />
							挑戰自我，追求卓越是我的核心價值，我期待著與我們的合作夥伴和客戶攜手合作，實現更多科技創新和成就，為台灣的安全和科技發展開創未來。
						</p>
						<h2>江家德 Leo</h2>
						<span>執行長</span>
					</div>
				</div>
			</div> -->

            <!-- <div class="teamArea">
				<div class="teamBox">
					<div class="wordBox">
						<h2>團隊</h2>
						<p>您永遠不會只得到我們一個人。 我們團隊的團結經驗與您相後。</p>
					</div>
					<div class="individualBox">
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(0, $event)"
								(mouseleave)="hideSummary(0)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(1, $event)"
								(mouseleave)="hideSummary(1)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(2, $event)"
								(mouseleave)="hideSummary(2)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(3, $event)"
								(mouseleave)="hideSummary(3)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(4, $event)"
								(mouseleave)="hideSummary(4)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
						<div class="memberBox">
							<div
								class="imgBox"
								(mouseenter)="displaySummary(5, $event)"
								(mouseleave)="hideSummary(5)"
							>
								<img
									src="../../../../assets/images/aboutKYPage/somebody.png"
									alt=""
								/>
							</div>
							<div class="vital">
								<p class="name">James</p>
								<span>投資人</span>
								<p
									#staffSummary
									class="summary"
								>
									擁有豐富的業務管理經驗的業務經理，專注於戰略規劃和團隊協作。曾在多個行業擔任關鍵管理職務，成功推動業績增長並提高客戶滿意度。
								</p>
							</div>
						</div>
					</div>
				</div>
			</div> -->

            <div class="advantageArea">
                <div class="advantageBox">
                    <div class="titleBox">
                        <h2>
                            {{ 'aboutKunYou.brandAdvantage.title' | translate }}
                        </h2>
                        <p>
                            {{ 'aboutKunYou.brandAdvantage.subtitle' | translate }}
                        </p>
                    </div>
                    <div class="swipeBox" *ngIf="showSwiper">
                        <swiper
                            [slidesPerView]="perPage"
                            [spaceBetween]="40"
                            [speed]="200"
                            [scrollbar]="{
							el: '.swiper-scrollbar',
						}"
                            [navigation]="{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'
                            }"
                            [observeParents]="true">
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2026_1.png"
                                        alt="2026_榮獲2026第23屆國家品牌玉山獎-傑出企業類"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2026No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_1.png"
                                        alt="2025_榮獲經濟部第24屆新創事業獎"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.honor2025No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_2.png"
                                        alt="2025_榮獲中華民國新型專利第M678045號「AI軌道安全監測與預警系統」"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.patent2025No03' | translate }}
                                    </p>
                                </div>
                            </ng-template> 
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_3.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.patent2025No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_4.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.patent2025No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_5.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2025No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2025_6.png"
                                        alt="2025_江家德執行長榮獲2025年華人公益大使「傳遞愛與關懷，共創美好社會」"
                                        width="100%" />

                                    <p></p>
                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.honor2025No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_1.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2024No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_2.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2024No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_3.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2024No03' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_4.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2024No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_5.jpg"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2024No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_6.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.patent2024No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_7.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.patent2024No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2024_8.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2024No03' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2023_1.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2023No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2023_2.jpg"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.membership2023No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2023_3.jpg"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2023No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2023_4.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.honor2023No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2023_5.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2023No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_1.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.honor2022No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_2.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2022No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_3.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2022No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_4.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2022No03' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_5.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2022No04' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_6.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.award2022No05' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_7.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.honor2022No02' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                            <ng-template swiperSlide>
                                <div class="info-card">
                                    <img
                                        src="/assets/images/aboutKYPage/2022_8.png"
                                        alt="國安局,National Security Bureau,NSB"
                                        width="100%" />

                                    <p>
                                        {{ 'aboutKunYou.brandAdvantage.achieve.cert2022No01' | translate }}
                                    </p>
                                </div>
                            </ng-template>
                        </swiper>
                        <div class="swiper-btm">
                            <div class="scroll">
                                <div class="swiper-scrollbar"></div>
                            </div>
                            <div class="action">
                                <button class="swiper-button-prev" aria-label="前一頁"></button>
                                {{ swiperPageRef }}
                                <button class="swiper-button-next" aria-label="下一頁"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="serviceItemArea">
                <div class="serviceItemBox">
                    <div class="titleBox">
                        <h2>
                            {{ 'aboutKunYou.milestones.title' | translate }}
                        </h2>
                    </div>
                    <div class="itemsBox">
                        <p-accordion [multiple]="true" [activeIndex]="[0]">
                            <ng-container
                                *ngFor="let major of 'aboutKunYou.milestones.entries' | translate; let index = index">
                                <p-accordionTab [header]="major.Year">
                                    <ng-container *ngFor="let detail of major?.Achieve; let index = index">
                                        <div class="entries">
                                            <time>{{ detail.Date }}</time>
                                            <p>{{ detail.Desc }}</p>
                                        </div>
                                    </ng-container>
                                </p-accordionTab>
                            </ng-container>
                        </p-accordion>
                    </div>
                </div>
            </div>
            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>
